export default "__VITE_ASSET__DLlXRHKF__"